import { render } from "./AgenteJornada.vue?vue&type=template&id=c8cd1d34&scoped=true"
import script from "./AgenteJornada.vue?vue&type=script&lang=ts"
export * from "./AgenteJornada.vue?vue&type=script&lang=ts"

import "./AgenteJornada.vue?vue&type=style&index=0&id=c8cd1d34&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-c8cd1d34"

export default script